import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 6,
  label: "专利类型分析",
  chart: charts.pie,
  definition: {
    rowDims: [
      {
        name: "patentType",
        label: "专利类型",
        needTotal: true,
      },
    ],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
  },
  chartOption: {
    chartType: ChartType.PIE,
    title: "专利类型分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false,
  },
};
